import {useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {AppContext} from "../utils/AppContext";
import {auth} from "../utils/firebaseApp";
import {toast} from "react-toastify";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import {Avatar, ButtonBase, IconButton, Menu, MenuItem, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {blue} from "@mui/material/colors";
import {signOut} from "firebase/auth";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

export const Header = ({toggleMenu, standName}) => {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const navigate = useNavigate();
    const {state: {currentUser}, dispatch} = useContext(AppContext);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const logout = () => {
        signOut(auth).then(() => {
            console.log('logging out')
            window.location.reload()
            navigate('/login')
        }).catch((error) => {
            console.log(error)
            toast.error("Something went wrong")
        });
        handleCloseUserMenu();
    }

    if (!currentUser) return null

    return (
        <AppBar
            position="sticky"
            color={"inherit"}
            elevation={0}
            sx={{zIndex: (theme) => theme.zIndex.drawer + 1, width: "100%", pt: 1}}
        >
            <Toolbar disableGutters>
                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}
                       sx={{width: "100%", px: 2}}>
                    <Stack direction={"row"} justifyContent={"flex-start"} alignContent={"center"}>
                        {/*<img src={logoImg} alt={"Logo"} height={50}/>*/}
                        <Typography variant={"h6"}
                                    sx={{fontWeight: "bold"}}>{standName ? standName : "BarTix"}</Typography>
                        {/*<Box sx={{m: "auto", display: {xs: "flex", md: "none"}}}>*/}
                        {/*    <IconButton sx={{my: "auto"}} onClick={toggleMenu}>*/}
                        {/*        <MenuIcon/>*/}
                        {/*    </IconButton>*/}
                        {/*</Box>*/}
                    </Stack>
                    <Box>
                        {/*<Button*/}
                        {/*    component={Link}*/}
                        {/*    to={"/create-survey"}*/}
                        {/*    sx={{mx: 2, px: 1, display: {xs: "none", md: "inline-flex"}}}*/}
                        {/*    variant={"contained"}*/}
                        {/*    className={"gradient-btn"}*/}
                        {/*>*/}
                        {/*    <AddIcon/> <Typography>Create Survey</Typography>*/}
                        {/*</Button>*/}
                        <Tooltip title="Open settings">
                            <ButtonBase onClick={handleOpenUserMenu} sx={{p: 0, mx: 2}}>
                                <Avatar sx={{bgcolor: blue[100], color: blue[500]}}>
                                    {/*<AccountCircleIcon/>*/}
                                    <Typography sx={{
                                        fontSize: 16,
                                        fontWeight: "bold"
                                    }}>{currentUser.email.slice(0, 2).toUpperCase()}</Typography>
                                </Avatar>
                                {/*<Typography color={"secondary"}*/}
                                {/*            sx={{ml: 1, fontWeight: "bold", display: {xs: "none", md: "block"}}}>Remy*/}
                                {/*    Sharp</Typography>*/}
                            </ButtonBase>
                        </Tooltip>
                        <Menu
                            sx={{mt: '45px'}}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem onClick={logout}>
                                <Typography textAlign="center">Logout</Typography>
                            </MenuItem>
                        </Menu>

                        <IconButton sx={{border: 1, borderColor: "divider", display: {xs: "none", md: "inline-flex"}}}>
                            <QuestionMarkIcon/>
                        </IconButton>
                    </Box>
                </Stack>
            </Toolbar>
        </AppBar>

    )
}
